import axios from 'axios';

/**
 * Handles backend logout call, clears user storage, and redirects.
 * @param {Function} [navigate] - Optional react-router navigate function
 */
export const logoutUser = async (navigate) => {
    try {
        // Optional: Send auth token in header if required by backend
        const token = localStorage.getItem("authToken");
        await axios.post( process.env.REACT_APP_API_URL + "/logout", {}, {
            headers: { Authorization: `Bearer ${token}` }
        });
    } catch (error) {
        console.error("Logout API error:", error);
    } finally {
        // Remove individual keys
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        localStorage.removeItem("permissions");
        localStorage.removeItem("role");

        // Redirect to login if a navigation handler was provided
        if (navigate) {
            navigate('/login');
        } else {
            window.location.href = '/login';
        }
    }
};